__turbopack_context__.v({
  "className": "albrafont_3e6eb6c8-module__Hgr9Uq__className",
  "variable": "albrafont_3e6eb6c8-module__Hgr9Uq__variable",
});
